import React from 'react'
import PropTypes from 'prop-types'

const DetailsPreview = ({ children, className = '' }) => {
    return (
        <div className={`details-preview ${className}`}>
            {children}
        </div>
    )
}

DetailsPreview.propTypes = {
    children: PropTypes.any.isRequired,
}

export default DetailsPreview
